import Icon from '@space-shell/common/components/icon'
import styled from 'styled-components'

export const CustomIcon = styled(Icon)<{ $isActive: boolean }>`
  transition: all var(--timing) var(--easing);
  transform: rotate(${(props) => (props.$isActive ? '180' : '0')}deg);
`

export const CustomButton = styled.button`
  cursor: pointer;
  background-color: transparent;
  padding: var(--button-padding);
  padding-left: 0;
  color: var(--gray-600);
  outline: 0;
  transition: background-color var(--timing) var(--easing), border-color var(--timing) var(--easing),
    box-shadow var(--timing) var(--easing), color var(--timing) var(--easing);
  user-select: none;
  vertical-align: middle;
  white-space: nowrap;

  &:hover,
  &:focus,
  &:active {
    outline: 0;
  }

  &:focus:active {
    border-color: var(--gray-400);
  }

  &[disabled] {
    cursor: not-allowed;
  }

  @media screen and (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
